"use client";

import React, { createContext, useState, useEffect, useContext } from "react";

import Cookies from "js-cookie";

export interface Currency {
  id?: number;
  symbol: string;
  exchangeRate: number;
  code: string;
}

interface CurrencyContextType extends Currency {
  changeCurrency: (item: Currency) => void;
  isInitialized: boolean;
}

const CurrencyContext = createContext<CurrencyContextType | undefined>(
  undefined
);

export const CurrencyProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [id, setId] = useState<number | undefined>();
  const [symbol, setSymbol] = useState<string | undefined>();
  const [exchangeRate, setExchangeRate] = useState<number | undefined>();
  const [code, setCode] = useState<string | undefined>();
  const [isInitialized, setIsInitialized] = useState<boolean>(false);

  const changeCurrency = (item: Currency) => {
    localStorage.setItem("currency", JSON.stringify(item));
    Cookies.set("currency", item.code, { expires: 365 });
    setId(item.id);
    setSymbol(item.symbol);
    setExchangeRate(item.exchangeRate);
    setCode(item.code);
    setIsInitialized(true);
  };

  useEffect(() => {
    const storedCurrency = localStorage.getItem("currency");
    if (storedCurrency) {
      try {
        const parsed: Currency = JSON.parse(storedCurrency);
        setId(parsed.id);
        setSymbol(parsed.symbol);
        setExchangeRate(parsed.exchangeRate);
        setCode(parsed.code);
      } catch (err) {
        console.error("Invalid currency data in localStorage", err);
      }
    }
    setIsInitialized(true);
  }, []);

  return (
    <CurrencyContext.Provider
      value={{
        id,
        symbol: symbol ?? "",
        exchangeRate: exchangeRate ?? 1,
        code: code ?? "",
        isInitialized,
        changeCurrency,
      }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error("useCurrency must be used inside CurrencyProvider");
  return ctx;
};
